import type { FilterType } from "@/store/modules/masterTemplateLibrary";

// Should be in sync with packages/after-effects/src/types.ts#6
export const TemplateType = {
    HTML5: "HTML5",
    PSD: "PSD",
    AE: "AE"
} as const;

export const TemplatesSortBy = {
    DATE_DESC: {
        dir: "desc",
        field: "modified"
    },
    DATE_ASC: {
        dir: "asc",
        field: "modified"
    },
    WIDTH_DESC: {
        dir: "desc",
        field: "width"
    },
    WIDTH_ASC: {
        dir: "asc",
        field: "width"
    }
} as const;

export type TemplateSortByKey = keyof typeof TemplatesSortBy;
export type TemplateSortByType = (typeof TemplatesSortBy)[TemplateSortByKey];

export type TemplateFilter = {
    type: keyof typeof FilterType;
    values: string[] | string;
};
